function removeMask() {
  $('.mask-container').fadeOut();
}

function pcBuyMd() {
  _hmt.push(['_trackEvent', 'pc', 'click', 'buy']);
  $('.mask-container').fadeIn();
}